import React from "react";

const StatisticAPIContext = React.createContext(null);

export default StatisticAPIContext;
